import type { Location, LocationFilters } from '@models/location'
import type { PaginatedResponse, PaginationMeta } from '@models/pagination'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import locationsApi from './actions'
import { locationsKeys } from './constants'

export interface UseLocationsData {
  locations: Location[]
  locationsMap: Map<number, Location>
  pagination: PaginationMeta
}

const selectData = ({
  data,
  pagination,
}: PaginatedResponse<Location>): UseLocationsData => ({
  locations: data,
  locationsMap: new Map(data.map(location => [location.id, location])),
  pagination,
})

const useLocations = (filters: LocationFilters) => {
  const query = useQuery<
    PaginatedResponse<Location>,
    AxiosError,
    UseLocationsData
  >(locationsKeys.list(filters), () => locationsApi.getLocations(filters), {
    select: selectData,
    enabled: !!filters.companyId,
  })
  return query
}

export default useLocations
